/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PoiInGeo
 */
export interface PoiInGeo {
    /**
     * 
     * @type {number}
     * @memberof PoiInGeo
     */
    geographyId: number;
}

export function PoiInGeoFromJSON(json: any): PoiInGeo {
    return PoiInGeoFromJSONTyped(json, false);
}

export function PoiInGeoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PoiInGeo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'geographyId': json['geographyId'],
    };
}

export function PoiInGeoToJSON(value?: PoiInGeo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'geographyId': value.geographyId,
    };
}


